import { HYDRATE } from 'next-redux-wrapper';

import {
    IMenuByTypesItem,
    TMenuKey as TMenuKeyFromResponse,
} from '@r1-frontend/api-domru/api-content/v2/menu/by-types';

import { InferValueTypes, THydrateAction } from '~/src/store';
import * as actionCreators from '~/src/store/actionCreators/menu';

import { SET_MENU_DATA } from '../actionTypes/menu';

export type TAuthorisationDependentMenuKey =  'authMain' | 'unauthMain';

export type TMenuKey = Exclude<TMenuKeyFromResponse, 'main'> | TAuthorisationDependentMenuKey;

export type INewMenuItems = Record<TMenuKey, IMenuByTypesItem[]>

export interface IMenuState {
    newMenuItems: null | INewMenuItems,
}

const initialState: IMenuState = {
    newMenuItems: null,
};

export type TActions = ReturnType<InferValueTypes<typeof actionCreators>>;

// todo: move to City
const menuReducer = (state = initialState, action: TActions| THydrateAction): IMenuState => {
    switch (action.type) {
        case HYDRATE:
            return { ...state, ...action.payload.menu };
        case SET_MENU_DATA:
            return {
                ...state,
                newMenuItems: {
                    ...state.newMenuItems,
                    ...action.payload,
                },
            };
        default:
            return state;
    }
};

export default menuReducer;
